export const HEADER_INFO = {
  leftItems: [
    {
      name: 'My Accounts',
      url: 'https://secure05.principal.com/member/accounts',
      external: true,
      target: '_self',
    },
    {
      name: 'Help',
      url: 'https://secure05.principal.com/allweb/docs/corporate/help.htm',
      external: true,
      target: '_self',
    },
  ],
  rightItems: [
    {
      name: 'My Hub',
      url: 'https://secure05.principal.com/individuals/invest/financial-planning-tool/my-hub',
      external: true,
      target: '_self',
      children: [],
    },
    {
      name: 'My Resources',
      url: 'https://secure05.principal.com/individuals/invest/myresources',
      external: true,
      target: '_blank',
      children: [],
    },
    {
      name: 'My Profile',
      url: null,
      external: false,
      target: null,
      children: [
        {
          name: 'Manage Profile',
          url: 'https://secure05.principal.com/yourprofile/isea/member/yourprofile.jsp',
          external: true,
          target: '_self',
        },
        {
          name: 'Beneficiaries',
          url: '/portal/clientdashboard/designations',
          external: true,
          target: '_self',
        },
      ],
    },
    {
      name: 'Log Out',
      url: process.env.VUE_APP_SSO_LOGOUT_URL,
      external: true,
      target: '_self',
      children: [],
    },
  ],
};
